import { render, staticRenderFns } from "./SensitivityConfig.vue?vue&type=template&id=1f05fbaa&scoped=true"
import script from "./SensitivityConfig.vue?vue&type=script&lang=ts"
export * from "./SensitivityConfig.vue?vue&type=script&lang=ts"
import style0 from "./SensitivityConfig.vue?vue&type=style&index=0&id=1f05fbaa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05fbaa",
  null
  
)

export default component.exports